function changeCheckboxState(container) {
  const rulesCheckbox = container.querySelector('.form-block__checkbox')
  const rulesCheckboxSvg = container.querySelector('.icon_check-filled')

  rulesCheckbox.addEventListener('change', (e) => {
    const checkboxState = e.target.checked ? 'check-filled' : 'check'
    const checkboxSvgHref = `/frontend/public/static/icons/symbol/common-sprite.svg#${checkboxState}`

    rulesCheckboxSvg.querySelector('use').setAttribute('xlink:href', checkboxSvgHref)
  })
}

const formReg = document.querySelector('#form-reg')

if (formReg) {
  changeCheckboxState(formReg)
}
